export default __webpack_public_path__ + "1.19.2/static/media/libreView.eba75fec.svg";